import styled from "styled-components";

export const Error = styled.p`
	color: red;
	padding-left: 15px;
	margin: 5px 0;
`;
